import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from '@react-pdf/renderer'

Font.register({
  family: 'Roboto',
  src: '/Roboto-Medium.ttf',
})

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    padding: 20,
    fontSize: 18,
  },
  title: {
    fontSize: 32,
    marginBottom: 20,
  },
  hr: {
    borderBottom: '1 solid lightgray',
    marginTop: '24px',
    marginBottom: '24px',
  },
})

type Delivery = {
  office: {
    name: string
  }
  canvasser: {
    full_name: string
    phone_number?: string
    email?: string
  }
  id: number
  forms: Array<unknown>
  turn_in_location: {
    name: string
  }
}

const Br = () => <Text>{'\n'}</Text>

const DeliveryReceipt = ({
  delivery,
  title,
}: {
  delivery: Delivery
  title: string
}) => (
  <Page style={styles.page}>
    <Text style={styles.title}>{title}</Text>

    <Text>Organization Name: {delivery.office.name}</Text>
    <Text>
      Organization Contact:{' '}
      {[
        delivery.canvasser.full_name,
        delivery.canvasser.phone_number,
        delivery.canvasser.email,
      ]
        .filter(Boolean)
        .join(', ')}
    </Text>
    <Br />
    <Text>Runner: {delivery.canvasser.full_name}</Text>
    <Text>Form Delivery Number: {delivery.id}</Text>
    <Text>Number of Voter Registration Forms: {delivery.forms.length}</Text>
    <Text>Delivery Location: {delivery.turn_in_location.name}</Text>

    <Br />
    <Text>Delivery Date: __________/__________/__________</Text>
    <View style={styles.hr} />
    <Text>Delivery Time: __________:__________ AM/PM</Text>
    <Br />
    <Text>Confirmation of Receipt:</Text>
    <Br />
    <Text>Clerk Name: __________________________________________________</Text>
    <Br />
    <Text>Clerk Signature: _____________________________________________</Text>
    <Br />
    <Text>Date: __________/__________/__________</Text>
    <Br />
    <Text>Time: __________:__________ AM/PM</Text>
  </Page>
)

DeliveryReceipt.Receipts = ({ delivery }: { delivery: Delivery }) => (
  <Document>
    <DeliveryReceipt delivery={delivery} title="FOR ELECTION CLERK" />
    <DeliveryReceipt delivery={delivery} title="FOR INTERNAL RECORDS" />
  </Document>
)

export default DeliveryReceipt
